


















import { editFactory } from '@/main/pages';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
	},
	data() {
		return {
			marks: {
				0: '0',
				1: '1',
				2: '1/2',
				3: '1/3',
				4: '1/4',
			},
		};
	},
	computed: {
		mutationsMappers() {
			return {
				nakladoveStredisko: `${this.storeUri}/${editMutations.PUJCOVNA_VOZIDEL_NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
			};
		},
	},
	methods: {
		onProvozovnaUpdate() {
			if (this.ProvozovnaId) {
				this.StrednaklOzn = null;
				this.StrednaklOznText = null;
			}
		},
	},
});
